/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface DatasetColumnMappingIn
 */
export interface DatasetColumnMappingIn {
  /**
   *
   * @type {string}
   * @memberof DatasetColumnMappingIn
   */
  columnName: string;
  /**
   *
   * @type {string}
   * @memberof DatasetColumnMappingIn
   */
  jsonPath: string;
}

/**
 * Check if a given object implements the DatasetColumnMappingIn interface.
 */
export function instanceOfDatasetColumnMappingIn(value: object): value is DatasetColumnMappingIn {
  if (!('columnName' in value) || value['columnName'] === undefined) return false;
  if (!('jsonPath' in value) || value['jsonPath'] === undefined) return false;
  return true;
}

export function DatasetColumnMappingInFromJSON(json: any): DatasetColumnMappingIn {
  return DatasetColumnMappingInFromJSONTyped(json, false);
}

export function DatasetColumnMappingInFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DatasetColumnMappingIn {
  if (json == null) {
    return json;
  }
  return {
    columnName: json['column_name'],
    jsonPath: json['json_path']
  };
}

export function DatasetColumnMappingInToJSON(value?: DatasetColumnMappingIn | null): any {
  if (value == null) {
    return value;
  }
  return {
    column_name: value['columnName'],
    json_path: value['jsonPath']
  };
}
